export default String.raw`
{% include 'partials/common/date-format.html' -%}	

{% assign offerString = customer-profile.OfferQueryGET -%}
{% assign paginationPageNo = customer-profile.Offers.PageNo -%}

<div class="eshop__table-container products">
	<table data-template="partials/customer-profile/offers/offer-details.html">
		<colgroup>
			<col style="width:100px">
			<col style="width:150px">
		</colgroup>
		<thead>
			<tr>
				<th class="id">{{ translations.Number | Capitalize }}</th>
				<th class="date">{{ translations.BuyDate }}</th>
				<th class="payment">{{ translations.Status }}</th>
			</tr>
		</thead>
		{% if customer-profile.Offers.TotalItems > 0 -%}
			{% for offer in customer-profile.Offers.List -%}
				<tbody>
					<tr tabindex="0" class="row can-hover load-deeper-lvl-js parent-container-reload-js open-order-details-js" data-id="{{ offer.Id }}" data-url="{{ page.Url }}?{{ offerString | H }}={{ offer.Id }}&deeper-lvl&tab=offer-details">
						<td class="id">{{ offer.Id }}</td>
						<td class="date">{{ offer.Date | Date:dateFormat }}</td>
						<td>
							<div class="state {% if offer.Status == 2 -%} warning-container {% elseif offer.Status == 4 or offer.Status == 3 -%} success-container {% else -%} danger-container {% endif -%}">{{ offer.StatusText }}</div>
						</td>
					</tr>
				</tbody>
			{% endfor -%}
		{% endif -%}
	</table>
	{% if customer-profile.Offers.TotalItems > 0 -%}
		{% include 'partials/common/pagination.html' -%}
	{% else -%}
		<div class="no-data">{{ translations.NoOffers }}</div>
	{% endif -%}
</div>
`